<script lang="ts">
  import { apiError, clearApiError } from '../stores/ui'
  import { tStore } from '../i18n'
</script>

{#if $apiError}
  <div class="banner" role="alert">
    <span class="banner__message">
      <strong>{$apiError.code}</strong>: {$apiError.message}
    </span>
    <button
      class="banner__dismiss"
      type="button"
      onclick={clearApiError}
      aria-label={$tStore('errors.dismiss')}
    >
      &times;
    </button>
  </div>
{/if}

<style lang="scss">
  @use '../assets/styles/variables' as v;

  .banner {
    display: flex;
    align-items: center;
    gap: v.$space-md;
    padding: v.$space-sm v.$space-lg;
    background: v.$color-danger-bg;
    color: v.$color-danger-fg;
    border-bottom: 1px solid #fca5a5;
  }

  .banner__message {
    flex: 1;
  }

  .banner__dismiss {
    background: none;
    border: none;
    color: inherit;
    font-size: 1.5rem;
    line-height: 1;
    cursor: pointer;
    padding: 0 v.$space-xs;
  }
</style>
